module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Desktop@1x.26beb053.jpg";